import React, { useState, useEffect, useRef } from "react";
import SVG_ChevronDownIcon from "../../assets/images/svgs/chevronDown3.svg?react";

export const mobileLengths = {
  91: 10,
  971: 9,
  880: 10,
  1: 10,
  92: 10,
  44: 10,
};

export const mobileFlag = {
  91: "in",
  971: "ae",
  880: "bd",
  1: "us",
  92: "pk",
  44: "gb",
};

const CountryCodeDropdown = ({ countryType, handleCountryType }) => {
  const dropdownRef = useRef(null);

  const [openDropdownCountry, setOpenDropdownCountry] = useState(false);
  const [dropdownAnimate, setDropdownAnimate] = useState("");

  const countryCodeList = [
    {
      id: "91",
      message: "+91",
      flag: "in",
    },
    {
      id: "971",
      message: "+971",
      flag: "ae",
    },
    {
      id: "880",
      message: "+880",
      flag: "bd",
    },
    {
      id: "1",
      message: "+1",
      flag: "us",
    },
    {
      id: "92",
      message: "+92",
      flag: "pk",
    },
    {
      id: "44",
      message: "+44",
      flag: "gb",
    },
  ];

  const handleCountrydropdown = () => {
    if (!openDropdownCountry) {
      setDropdownAnimate("popUpOpenAnimation");
      setOpenDropdownCountry(true);
    } else {
      setDropdownAnimate("popUpCloseAnimation");
      setTimeout(() => {
        setOpenDropdownCountry(false);
      }, 200);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownAnimate("popUpCloseAnimation");
        setTimeout(() => {
          setOpenDropdownCountry(false);
        }, 200);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <span className=" h-fit" ref={dropdownRef}>
      <div className="w-full h-full relative ">
        <div className=" block z-100 h-full">
          <div
            id="dropdownDefaultButton"
            className="w-full cursor-pointer relative hover:undefined font-medium  rounded-r-sm min-h-[35px] text-sm  pr-6 text-center inline-flex items-center  text-text_Quaternary"
            onClick={() => {
              handleCountrydropdown();
            }}
          >
            <SVG_ChevronDownIcon
              className={`w-5 h-5 ms-3 absolute right-1 transform transition-all ease-in-out duration-200 ${
                openDropdownCountry ? "-rotate-180" : ""
              }`}
            />
          </div>

          {openDropdownCountry && (
            <div
              id="dropdown"
              className={`${dropdownAnimate} bg-bg_Quaternary left-1  origin-top-right top-[102%]  absolute  z-10  divide-y divide-gray-500 rounded-lg shadow w-max  bg-bg_Quaternary text-text_Secondary`}
            >
              <ul className="py-1 text-sm text-text_Quaternary">
                {countryCodeList.map((item, index) => {
                  return (
                    <li
                      key={`${item.id}-dropdown`}
                      className={` active:bg-bg_Secondary   ${
                        index == 0
                          ? "border-b-[1px] pb-1"
                          : "text-text_Primary  pt-1"
                      }`}
                    >
                      <button
                        type="button"
                        className="w-full px-4 py-1 grid grid-cols-4"
                        onClick={() => {
                          setDropdownAnimate("popUpCloseAnimation");
                          setTimeout(() => {
                            setOpenDropdownCountry(false);
                            handleCountryType(item.id);
                          }, 200);
                        }}
                      >
                        <span className=" col-span-1 flex items-center justify-center ">
                          <span className="f32">
                            <div className={`flag ${item.flag} w-full`}></div>
                          </span>
                        </span>
                        <span
                          className={` col-span-3 pl-2 font-normal f] font-lato text-start text-red-600  ${
                            item.id == countryType
                              ? "text-text_Primary"
                              : "text-gray-500"
                          } `}
                        >
                          {item?.message}
                        </span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
    </span>
  );
};

export default CountryCodeDropdown;
